import { render } from "./LanguageInformation.component.vue?vue&type=template&id=09780460&scoped=true"
import script from "./LanguageInformation.component.vue?vue&type=script&lang=js"
export * from "./LanguageInformation.component.vue?vue&type=script&lang=js"

import "./LanguageInformation.component.vue?vue&type=style&index=0&id=09780460&lang=scss&scoped=true"
import "./LanguageInformation.component.vue?vue&type=style&index=1&id=09780460&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09780460"]])

export default __exports__